<template>
  <section class="uk-section">
    <h3 id="link4"><i class="icon uk-icon uk-icon-image" :style="{backgroundImage: `url( ${require('@/assets/images/icon/javascript-outline.svg')})`}"></i>JavaScript</h3>
    <div class="uk-child-width-1-4@l uk-child-width-1-3@m uk-child-width-1-2@s uk-grid-medium" uk-grid>
      <!-- <item-list v-for="(item, imgUrl, title, text, itemLink) of items" :item="item" :key="item.id" :imgUrl="imgUrl" :title="title" :text="text" :itemLink="itemLink"></item-list> -->
      <item-list v-for="item of items" :item="item" :key="item.id"></item-list>
    </div>
  </section>
</template>

<script>
import ItemList from '@/components/ItemList'
import GuideData from '@/_data/guide.json'
export default {
  // el: '#item-list',
  components: {
    'item-list': ItemList
  },
  data () {
    return {
      items: GuideData.javascript
    }
  }
}
</script>
